<div class="card">
  <div class="card-body p-0">
    <app-base-list
      *ngIf="listConfig"
      [config]="listConfig"
      [data]="reasons"
      [totalRecords]="reasons.length"
      [loading]="loading"
      [paginator]="false"
      [rows]="1000" />
    <div *ngIf="!loading" class="px-3 py-2">
      <span class="small text-muted">
        {{ reasons.length }}
        {{ 'Settings::WorkEnvironment:DeclineReasons:ReasonCount' | abpLocalization }}
      </span>
    </div>
  </div>
</div>

<ng-template #nameTpl let-row>
  <span>{{ row.name }}</span>
</ng-template>

<ng-template #queuesTpl let-row>
  <ng-container *ngIf="row.queues?.length; else noQueues">
    <div class="d-flex flex-wrap gap-2 align-items-center">
      <p-tag *ngFor="let q of getQueuesInline(row.queues); trackBy: trackById" [value]="q.name"></p-tag>
      <span
        *ngIf="hasQueueOverflow(row.queues)"
        class="d-inline-flex align-items-center"
        [pTooltip]="getQueuesTooltip(row.queues)"
        tooltipPosition="top"
        appendTo="body">
        <p-tag [value]="'+' + getQueueOverflowCount(row.queues)"></p-tag>
      </span>
    </div>
  </ng-container>
  <ng-template #noQueues>
    <span class="text-muted">—</span>
  </ng-template>
</ng-template>

<ng-template #actionsTpl let-row>
  <app-action-menu [items]="getMenuItems(row)"></app-action-menu>
</ng-template>
